import { LinearProgress } from '@material-ui/core'
import { styled } from 'opensolar-ui'
import { FileRecord } from '../controller/UploadFileContext'

type UploadFileProgressProps = {
  fileRecord: FileRecord
}

const BottomLinearProgress = styled(LinearProgress)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: 3,
  borderRadius: 0,
})

export const UploadFileItemBottomProgress = ({ fileRecord }: UploadFileProgressProps) => {
  if (fileRecord.uploadStatus !== 'uploading') return null
  return <BottomLinearProgress variant="indeterminate" color="primary" />
}
